import TalentPools from './TalentPools';

export default TalentPools;
